import { gql } from '@apollo/client';

export const NotificationSubscriptionGQL = gql`
  subscription notificationCreatedSubscriptions {
    notificationCreated {
      action
      createdAt
      id
      imageUrl
      messageHtml
      messageText
      read
      entityId
      clicked
    }
  }
`;
